// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ApplyHero — /apply hero banner
   ============================================================ */
.aph {
  position: relative;
  height: clamp(400px, 75vh, 700px);
  background: var(--c-cream);
  overflow: hidden;
  isolation: isolate;
}

.aph__media {
  position: absolute;
  inset: 0;
  mix-blend-mode: multiply;
  z-index: -1;
}

.aph__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 68% center;
}

/* Cream scrim — heavy left, photo shows right */
.aph__scrim {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      100deg,
      var(--c-cream) 0%, var(--c-cream) 24%,
      rgba(244,239,230,0.9) 38%,
      rgba(244,239,230,0.28) 56%,
      rgba(244,239,230,0.04) 74%
    ),
    linear-gradient(to top, rgba(27,27,27,0.18) 0%, rgba(27,27,27,0) 40%);
}

.aph__inner {
  position: relative;
  height: 100%;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: clamp(1rem, 2.5vw, 2.25rem);
  padding-top: 64px;
  z-index: 3;
}

.aph__content {
  max-width: 42rem;
  display: flex;
  flex-direction: column;
  gap: clamp(0.85rem, 1.4vw, 1.2rem);
}

.aph__eyebrow {
  color: var(--accent) !important;
  letter-spacing: 0.24em;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.aph__eyebrow::after {
  content: "";
  display: block;
  width: clamp(1.5rem, 3vw, 3rem);
  height: 1px;
  background: var(--accent);
  opacity: 0.6;
}

.aph__title {
  font-size: clamp(2.8rem, 8vw, 7rem);
  line-height: 0.9;
  margin: 0;
}

.aph__sub {
  font-family: var(--font-body);
  font-size: clamp(0.88rem, 1.1vw, 1rem);
  color: var(--c-ink);
  line-height: 1.7;
  max-width: 28rem;
  margin: 0;
}

/* CTA button — rust filled with arrow */
.aph__cta {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--accent);
  color: var(--on-accent);
  text-decoration: none;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  padding: 1rem 1.75rem;
  border-radius: 0;
  transition: background var(--dur) var(--ease), gap var(--dur) var(--ease);
}
.aph__cta:hover { background: var(--accent-hover); gap: 1rem; color: var(--on-accent); }
.aph__cta-icon  { font-size: 0.7rem; }

@media (max-width: 767.98px) {
  .aph { height: clamp(360px, 78vw, 520px); }
  .aph__inner { grid-template-columns: 1fr; padding-inline: var(--gutter); }
  .aph__rail  { display: none; }
  .aph__content { max-width: 100%; }
  .aph__title { font-size: clamp(2.4rem, 11vw, 4.5rem); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyHero.css"],"names":[],"mappings":"AAAA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;;;;yEAQuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yEAAyE;AAC3E;AACA,kBAAkB,+BAA+B,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACvF,kBAAkB,iBAAiB,EAAE;;AAErC;EACE,OAAO,iCAAiC,EAAE;EAC1C,cAAc,0BAA0B,EAAE,6BAA6B,EAAE;EACzE,cAAc,aAAa,EAAE;EAC7B,gBAAgB,eAAe,EAAE;EACjC,cAAc,sCAAsC,EAAE;AACxD","sourcesContent":["/* ============================================================\n   ApplyHero — /apply hero banner\n   ============================================================ */\n.aph {\n  position: relative;\n  height: clamp(400px, 75vh, 700px);\n  background: var(--c-cream);\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.aph__media {\n  position: absolute;\n  inset: 0;\n  mix-blend-mode: multiply;\n  z-index: -1;\n}\n\n.aph__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 68% center;\n}\n\n/* Cream scrim — heavy left, photo shows right */\n.aph__scrim {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(\n      100deg,\n      var(--c-cream) 0%, var(--c-cream) 24%,\n      rgba(244,239,230,0.9) 38%,\n      rgba(244,239,230,0.28) 56%,\n      rgba(244,239,230,0.04) 74%\n    ),\n    linear-gradient(to top, rgba(27,27,27,0.18) 0%, rgba(27,27,27,0) 40%);\n}\n\n.aph__inner {\n  position: relative;\n  height: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  column-gap: clamp(1rem, 2.5vw, 2.25rem);\n  padding-top: 64px;\n  z-index: 3;\n}\n\n.aph__content {\n  max-width: 42rem;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.85rem, 1.4vw, 1.2rem);\n}\n\n.aph__eyebrow {\n  color: var(--accent) !important;\n  letter-spacing: 0.24em;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.aph__eyebrow::after {\n  content: \"\";\n  display: block;\n  width: clamp(1.5rem, 3vw, 3rem);\n  height: 1px;\n  background: var(--accent);\n  opacity: 0.6;\n}\n\n.aph__title {\n  font-size: clamp(2.8rem, 8vw, 7rem);\n  line-height: 0.9;\n  margin: 0;\n}\n\n.aph__sub {\n  font-family: var(--font-body);\n  font-size: clamp(0.88rem, 1.1vw, 1rem);\n  color: var(--c-ink);\n  line-height: 1.7;\n  max-width: 28rem;\n  margin: 0;\n}\n\n/* CTA button — rust filled with arrow */\n.aph__cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: var(--accent);\n  color: var(--on-accent);\n  text-decoration: none;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  padding: 1rem 1.75rem;\n  border-radius: 0;\n  transition: background var(--dur) var(--ease), gap var(--dur) var(--ease);\n}\n.aph__cta:hover { background: var(--accent-hover); gap: 1rem; color: var(--on-accent); }\n.aph__cta-icon  { font-size: 0.7rem; }\n\n@media (max-width: 767.98px) {\n  .aph { height: clamp(360px, 78vw, 520px); }\n  .aph__inner { grid-template-columns: 1fr; padding-inline: var(--gutter); }\n  .aph__rail  { display: none; }\n  .aph__content { max-width: 100%; }\n  .aph__title { font-size: clamp(2.4rem, 11vw, 4.5rem); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
